// @flow
import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Strong } from '@finect/tabular-core/Strong';
import { Small } from '@finect/tabular-core/Small';
import { AppLink } from '@finect/tabular-core/AppLink';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Link } from 'react-router-dom';
import type { TagType } from '../../types';

/* eslint-disable */
export const WhiteState = styled(Paragraph)`
  &:not(:last-child) {
    padding-bottom: 0;
  }

  ${maxMediaQueries.phablet`
    padding-top: 15px;

    ${/*sc-sel*/ Strong} {
      padding-bottom: 6px;
    }
  `};
`;
/* eslint-enable */

type Props = {
  topic?: TagType
};

export const NotFollowedQuestions = ({ topic }: Props) => (
  <WhiteState center textCenter>
    <Strong>Actualmente no sigues ninguna pregunta{topic ? ` sobre ${topic.name}` : ''}.</Strong>
    <br />
    <Small>
      Si alguna pregunta{topic ? ' sobre este tema' : ''} capta tu atención puedes seguirla y la verás en esta pestaña.
    </Small>
  </WhiteState>
);

export const NotFollowedTags = () => (
  <WhiteState center textCenter>
    <Strong>Actualmente no sigues ningún tema.</Strong>
    <br />
    <Small>
      <AppLink
        as={Link}
        to={{
          pathname: '/preguntas/temas',
          state: { fromApp: true, backPath: '/preguntas/mis-temas' }
        }}
      >
        Descubre los diferentes temas
      </AppLink>{' '}
      y sigue los que más te interesen. Todas las preguntas aparecerán en esta pestaña.
    </Small>
  </WhiteState>
);

export const NotOwnQuestions = () => (
  <WhiteState center textCenter>
    <Strong>Aún no has creado ninguna pregunta.</Strong>
    <br />
    <Small>
      <AppLink as={Link} to="/preguntas/nueva-pregunta" rel="nofollow">
        Crea tu primera pregunta
      </AppLink>{' '}
      y deja que la comunidad de Finect te ayude a resolver tus dudas.
    </Small>
  </WhiteState>
);

export const NotTopicQuestions = ({ topic }: Props) => {
  const saveTag = () => {
    localStorage.setItem(
      'questionTags',
      JSON.stringify({
        content: JSON.stringify([topic]),
        timestamp: new Date().getTime()
      })
    );
  };

  return (
    <WhiteState center textCenter>
      <Strong>Aún no hay ninguna pregunta sobre este tema.</Strong>
      <br />
      <Small>
        Puedes ser el primero en{' '}
        <AppLink to="/preguntas/nueva-pregunta" rel="nofollow" onClick={saveTag}>
          crear una pregunta sobre {topic && topic.name}
        </AppLink>
        .
      </Small>
    </WhiteState>
  );
};
